import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from './plugin'

export class Selectors {
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly palette

  // NOTE: intentionally not typed here so that type can be inferred
  public readonly getColorFor

  constructor(plugin: Plugin<any>) {
    this.palette = plugin.feature.state.project(state => state.palette)

    this.getColorFor = plugin.feature.createSelectorMethod(
      (id: ec.models.EntityId) =>
        store.selectors.Selector.create(this.palette.asSelector, palette =>
          palette.getColorAssignedTo(id),
        ),
    )
  }
}
